import React from 'react';
import PropTypes from 'prop-types';
import {
  Alert,
  Button,
  Form,
  FormFeedback,
  FormGroup,
  Input,
  InputGroup,
  Label
} from 'reactstrap';
import { Field, Fields, reduxForm } from 'redux-form';
import cx from 'classnames';
import { email, length, required } from 'redux-form-validators';
// components
import Filter from '../../components/form/filter';
import FormField from '../../components/form/field/field';

// decorators
import withField from '../../decorators/with-field';

// modules
import styles from '../../components/form/form.module.scss';

const InputField = withField(Input);

const CityStateFields = props => {
  const { city, state, states, tabIndex, BS } = props;
  return (
    <FormGroup>
      <InputGroup>
        <Label
          className={cx(styles.label, BS.mr3, BS.mb0, BS.alignSelfCenter)}
          for="city"
        >
          Primary Residence:
        </Label>
        <Field
          {...city}
          name="city"
          type="text"
          placeholder="City"
          component={InputField}
          tabIndex={tabIndex ? tabIndex : undefined}
          className={BS.mr3}
          invalid={!!(city.meta.error || city.meta.warning) && city.meta.touched}
        />
        <Filter
          {...state}
          name="state"
          componentClass={InputField}
          renderType="select"
          placeholder="State"
          tabIndex={tabIndex ? tabIndex + 1 : undefined}
          items={states}
          invalid={!!(state.meta.error || state.meta.warning) && state.meta.touched}
        />
      </InputGroup>
      {(city.meta.error || city.meta.warning) && city.meta.touched && (
        <FormFeedback className={BS.dBlock}>
          {city.meta.error || city.meta.warning}
        </FormFeedback>
      )}
      {(state.meta.error || state.meta.warning) && state.meta.touched && (
        <FormFeedback className={BS.dBlock}>
          {state.meta.error || state.meta.warning}
        </FormFeedback>
      )}
    </FormGroup>
  );
};

let ContactForm = (
  {
    handleSubmit,
    onCancelClick,
    states,
    invalid,
    valid,
    reset,
    error,
    submitSucceeded,
    ...props
  },
  context
) => {
  const BS = context.theme;

  return (
    <Form onSubmit={handleSubmit}>
      {!submitSucceeded && (
        <div>
          <p>
            Naples Area Board of REALTORS<sup>®</sup>
            <br />
            and Association of Real Estate Professionals
            <br />
            1455 Pine Ridge Road
            <br />
            Naples, Florida 34109
            <br />
          </p>
          <p>Please fill out the information below and send us your comments.</p>
        </div>
      )}
      {error && <Alert color="danger">{error}</Alert>}
      {submitSucceeded && (
        <Alert color="success">
          An email has been sent to naplesarea.com. Someone will respond to you shortly.
        </Alert>
      )}
      {!submitSucceeded && (
        <div>
          <FormGroup>
            <Label className={styles.label} for="firstName">
              First Name:
            </Label>
            <Field
              name="firstName"
              type="text"
              placeholder="First Name"
              component={FormField}
              required
              validate={[required(), length({ max: 255 })]}
            />
          </FormGroup>
          <FormGroup>
            <Label className={styles.label} for="lastName">
              Last Name:
            </Label>
            <Field
              name="lastName"
              type="text"
              placeholder="Last Name"
              component={FormField}
              required
              validate={[required(), length({ max: 255 })]}
            />
          </FormGroup>
          <FormGroup>
            <Label className={styles.label} for="email">
              Email Address:
            </Label>
            <Field
              name="email"
              type="email"
              placeholder="Email Address"
              component={FormField}
              required
              validate={[required(), email(), length({ max: 255 })]}
            />
          </FormGroup>

          <Fields
            names={['city', 'state']}
            component={CityStateFields}
            states={states}
            BS={BS}
          />
          <FormGroup>
            <InputGroup>
              <Label className={cx(styles.label, BS.mr3)} for="contactWorkingWith">
                Are you currently working with a REALTOR<sup>®</sup>?:
              </Label>
              <Field
                name="contactWorkingWith"
                renderType="radio"
                component={FormField}
                componentClass={Filter}
                passthrough
                items={[
                  { label: 'Yes', value: '1' },
                  { label: 'No', value: '0' }
                ]}
                validate={[required(), length({ max: 1 })]}
              />
            </InputGroup>
          </FormGroup>
          <FormGroup>
            <InputGroup>
              <Label className={cx(styles.label, BS.mr3)} for="contactMember">
                Are you a REALTOR® member of NABOR?:
              </Label>
              <Field
                name="contactMember"
                renderType="radio"
                component={FormField}
                componentClass={Filter}
                passthrough
                items={[
                  { label: 'Yes', value: '1' },
                  { label: 'No', value: '0' }
                ]}
                validate={[required(), length({ max: 1 })]}
              />
            </InputGroup>
          </FormGroup>
          <FormGroup>
            <Label className={styles.label} for="comments">
              Please tell us what you enjoy about Naplesarea.com:
            </Label>
            <Field
              name="comments"
              type="textarea"
              placeholder=""
              component={FormField}
              validate={[length({ max: 10000 })]}
            />
          </FormGroup>
          <FormGroup>
            <Label className={styles.label} for="suggestions">
              Please tell us what you would like to see on Naplesarea.com:
            </Label>
            <Field
              name="suggestions"
              type="textarea"
              placeholder=""
              component={FormField}
              validate={[length({ max: 10000 })]}
            />
          </FormGroup>
          <div className={cx(BS.dFlex, BS.justifyContentBetween, BS.mb3)}>
            <Button
              color="warning"
              onClick={e => {
                reset(e);
                if (onCancelClick) {
                  onCancelClick(e);
                }
              }}
            >
              Cancel
            </Button>
            <Button color="primary" type="submit" disabled={invalid}>
              Submit
            </Button>
          </div>
        </div>
      )}
    </Form>
  );
};

ContactForm.contextTypes = {
  theme: PropTypes.object
};

export default reduxForm({
  form: 'contact-form'
})(ContactForm);



// WEBPACK FOOTER //
// ./src/forms/contact-form/contact-form.js